(() => {
  const inboxActivator = () => {
    const chat = document.querySelector('shopify-chat');
    const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
    const activator = runtime?.shadowRoot?.querySelector('[part~="activator"], .activator');
    activator?.style.setProperty('display', 'none', 'important');
    return activator;
  };

  const openInbox = (attempt = 0) => {
    const activator = inboxActivator();
    if (activator) {
      if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
      return;
    }

    if (attempt < 40) {
      window.setTimeout(() => openInbox(attempt + 1), 200);
      return;
    }

    window.location.assign('/pages/contact');
  };

  const install = (root) => {
    if (root.dataset.manualGuard) return;
    root.dataset.manualGuard = 'true';
    const panel = root.querySelector('.pp-assistant-panel');
    const launcher = root.querySelector('.pp-assistant-launcher');
    if (!panel || !launcher) return;
    const close = () => {
      panel.removeAttribute('data-manual-open');
      panel.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
    };
    close();
    root.addEventListener('click', (event) => {
      if (event.target.closest('.pp-assistant-close')) close();
    }, true);
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    new MutationObserver(() => {
      if (!panel.hasAttribute('data-manual-open') && !panel.hidden) close();
    }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  };
  window.addEventListener('click', (event) => {
    const launcher = event.target.closest?.('.pp-assistant-launcher');
    if (!launcher) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const root = launcher.closest('[data-plakperso-assistant]');
    const panel = root?.querySelector('.pp-assistant-panel');
    if (panel) {
      panel.removeAttribute('data-manual-open');
      panel.hidden = true;
    }
    launcher.setAttribute('aria-expanded', 'false');
    openInbox();
  }, true);
  const scan = () => document.querySelectorAll('[data-plakperso-assistant]').forEach(install);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
